import React, { useEffect, useState } from "react";
import Layout from "../Layout/Layout.js";
import DataTable from "react-data-table-component";
import { APIUrl } from "../../Helper/APIUrl.js";
import { SnackbarProvider, useSnackbar } from "notistack";

function ManageVendors() {
  const { enqueueSnackbar } = useSnackbar();

  const Token = JSON.parse(localStorage.getItem("tcn"));

  const [search, setsearch] = useState("");
  const [lstVendorLogin, setlstVendorLogin] = useState([]);
  const [filterlstVendorLogin, setfilterlstVendorLogin] = useState([]);

  const [lstVendorProperties, setlstVendorProperties] = useState([]);
  const [VendorId, setVendorId] = useState("");
  const [VendorEmail, setVendorEmail] = useState("");
  const [VendorUser, setVendorUser] = useState("");
  const [IsPostStatus, setIsPostStatus] = useState(false);

  const ConcateURL = APIUrl.VendorLogin;

  const parseJSON = async (response) => {
    try {
      if (response.status === 204 || response.status === 205) return null;
      const text = await response.text();
      if (!text) return null;
      return JSON.parse(text);
    } catch (err) {
      console.warn("Failed to parse JSON response", err);
      return null;
    }
  };

  const getAllVendorLogin = async () => {
    try {
      const response = await fetch(ConcateURL + "GetAllVendorLogin", {
        method: "Post",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Token}`,
        },
        body: JSON.stringify({}),
      });
      const result = await parseJSON(response);
      if (result?.data != null) {
        setlstVendorLogin(result.data.sort((a, b) => b.VendorId - a.VendorId));
        setfilterlstVendorLogin(
          result.data.sort((a, b) => b.VendorId - a.VendorId),
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getAllVendorLogin();
  }, []);

  useEffect(() => {
    const result = lstVendorLogin.filter((x) => {
      return (
        x.VendorId?.toString().toLowerCase().includes(search.toLowerCase()) ||
        x.UserName?.toLowerCase().includes(search.toLowerCase()) ||
        x.Password?.toLowerCase().includes(search.toLowerCase()) ||
        x.Email?.toLowerCase().includes(search.toLowerCase()) ||
        x.PasswordChangeCount?.toString()
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        x.LastPasswordChangeDate?.toString()
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        x.Remarks?.toLowerCase().includes(search.toLowerCase()) ||
        x.IsApproved?.toString().toLowerCase().includes(search.toLowerCase()) ||
        x.IsActive?.toString().toLowerCase().includes(search.toLowerCase()) ||
        x.CreatedBy?.toString().toLowerCase().includes(search.toLowerCase()) ||
        x.CreatedOn?.toString().toLowerCase().includes(search.toLowerCase()) ||
        x.ModifyBy?.toString().toLowerCase().includes(search.toLowerCase()) ||
        x.ModifiedOn?.toString().toLowerCase().includes(search.toLowerCase())
      );
    });
    setfilterlstVendorLogin(result);
  }, [search, lstVendorLogin]);

  const formatDate = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (isNaN(date.getTime())) return "-";
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatBoolean = (value) => {
    if (value === null || value === undefined) return "-";
    return value ? "Yes" : "No";
  };

  const handleViewVendor = (
    vendorPropertiesList,
    vendorEmail,
    vendorUser,
    vendorId,
  ) => {
    const properties =
      lstVendorLogin.find((x) => x.VendorId === vendorId)?._objNewProperty ||
      vendorPropertiesList ||
      [];
    if (!properties || properties.length === 0) {
      enqueueSnackbar("No properties found for this vendor.", {
        variant: "info",
      });
      return;
    } else {
      setlstVendorProperties(properties);
      setVendorEmail(vendorEmail);
      setVendorUser(vendorUser);
      setIsPostStatus(true);
      setVendorId(vendorId);

      clearTimeout(window.vendorViewTimeout);
      window.vendorViewTimeout = setTimeout(() => {
        setIsPostStatus(false);
        setlstVendorProperties([]);
        setVendorEmail("");
        setVendorUser("");
        setVendorId("");
      }, 30000); // Clear vendor details after 30 seconds of inactivity
    }
  };

  const ActivateVendorLogin = async (isActive, vendorId) => {
    try {
      debugger;
      const response = await fetch(
        ConcateURL + "ActivateDeactivateVendorLogin",
        {
          method: "Post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
          body: JSON.stringify({ VendorId: vendorId, IsActive: isActive }),
        },
      );
      const result = await parseJSON(response);
      if (result.Message == "Success") {
        enqueueSnackbar(
          `Vendor ${isActive ? "activated" : "blocked"} successfully.`,
          { variant: "success" },
        );
        getAllVendorLogin();
      } else {
        enqueueSnackbar(result?.message || "Failed to update vendor status.", {
          variant: "error",
        });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("An error occurred while updating vendor status.", {
        variant: "error",
      });
    }
  };

  const OnOffWhatsappChatVendorLogin = async (IsWhatsAppChat, vendorId) => {
    try {
      const response = await fetch(
        ConcateURL + "IsApproveWhatsAppChatforUserVendorLogin",
        {
          method: "Post",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Token}`,
          },
          body: JSON.stringify({
            VendorId: vendorId,
            IsWhatsAppChat: !IsWhatsAppChat,
          }),
        },
      );
      const result = await parseJSON(response);
      if (result.Message == "Success") {
        enqueueSnackbar(
          `Vendor Whatsapp chat ${!IsWhatsAppChat ? "activated" : "deactivated"} successfully.`,
          { variant: "success" },
        );
        getAllVendorLogin();
      } else {
        enqueueSnackbar(result?.message || "Failed to update vendor status.", {
          variant: "error",
        });
      }
    } catch (error) {
      console.log(error);
      enqueueSnackbar("An error occurred while updating vendor status.", {
        variant: "error",
      });
    }
  };

  const coloumn = [
    {
      name: "SNo.",
      selector: (row, index) => index + 1,
      width: "70px",
    },
    {
      name: "Post Status",
      cell: (row) => (
        <button
          onClick={() =>
            handleViewVendor(
              row?._objNewProperty,
              row?.Email,
              row?.UserName,
              row?.VendorId,
            )
          }
          className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800 hover:bg-blue-200"
        >
          View
        </button>
      ),
      width: "110px",
    },

    {
      name: "Vendor ID",
      cell: (row) => (
        <button
          className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
            !row.IsActive
              ? "bg-red-100 text-red-800 hover:bg-red-200"
              : "bg-green-100 text-green-800 hover:bg-green-200"
          }`}
          onClick={() => {
            setVendorId(row.VendorId);
            ActivateVendorLogin(row.IsActive ? false : true, row.VendorId);
          }}
        >
          {!row.IsActive ? "Blocked" : "Activated"}
        </button>
      ),
      width: "130px",
    },
    {
      name: "On/Off WhatApp chat Direct for User",
      cell: (row) => (
        <button
          onClick={() =>
            OnOffWhatsappChatVendorLogin(row?.IsWhatsAppChat, row?.VendorId)
          }
          className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${!row?.IsWhatsAppChat ? "bg-red-100 text-red-800 hover:bg-red-200" : "bg-green-100 text-green-800 hover:bg-green-200"}`}
        >
          {row?.IsWhatsAppChat ? "Chat On" : "Chat Off"}
        </button>
      ),
      width: "130px",
    },
    {
      name: "Username",
      selector: (row) => row.UserName + " " + row.Email,
      cell: (row) => (
        <div className="flex flex-col gap-2 mt-1 mb-1">
          <div className="flex flex-col gap-2 mt-1 mb-1">
            <span className="font-bold text-medium text-gray-900">
              {row.UserName}
            </span>
          </div>
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-pink-100 text-pink-800">
            Registeration Date: {formatDate(row.CreatedOn)}
          </span>
          
        </div>
      ),
      sortable: true,
      width: "270px",
    },
    {
      name: "User Credentials",
      selector: (row) => row.UserName + " " + row.Email,
      cell: (row) => (
        <div className="flex flex-col gap-2 mt-1 mb-1">
          <span className="text-sm text-gray-500">Login: {row.Email}</span>
          <span className="text-sm text-gray-500">Pass: {row.Password}</span>
        </div>
      ),
      sortable: true,
      width: "250px",
    },
    {
      name: "User Details",
      selector: (row) => row.FullName + " " + row.Phone,
      cell: (row) => (
        <div className="flex flex-col gap-2 mt-1 mb-1">
          <span className="text-sm text-gray-700 font-medium">
            Name: {row.FullName}
          </span>
          <span className="text-sm text-gray-500">Mobile: {row.Phone}</span>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Vendor Profile",
      selector: (row) => row.FullName + " " + row.Phone,
      cell: (row) => (
        <div className="flex flex-col gap-2 mt-1 mb-1">
          <span className="text-sm text-gray-700 font-medium">
            Company: {row.Company}
          </span>
          <span className="text-sm text-gray-500">
            Position: {row.Position}
          </span>
          <span className="text-sm text-gray-500">
            Job Profile: {row.JobProfile}
          </span>
          <span className="text-sm text-gray-500">
            Facebook: {row.Facebook}
          </span>
          <span className="text-sm text-gray-500">Twitter: {row.Twitter}</span>
          <span className="text-sm text-gray-500">LinkedIn: {row.Linkdin}</span>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
  ];

  return (
    <div>
      <Layout>
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          {lstVendorProperties.length > 0 && IsPostStatus && (
            <div className="space-y-6 mb-6">
              <div className="bg-white rounded-xl shadow-sm border border-pink-200 p-6">
                <div>
                  <h2 className="text-xl font-semibold text-pink-900 mb-6">
                    Properties Status of Vendor: {VendorUser} | {VendorEmail}
                  </h2>
                </div>
                <div className="grid grid-cols-1 gap-6">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
                    <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-lg p-6 border border-red-200 cursor-pointer hover:shadow-lg transition-shadow">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm font-medium text-red-800">
                            Deleted Properties
                          </p>
                          <p className="text-3xl font-bold text-red-600 mt-2">
                            {
                              lstVendorProperties.filter(
                                (x) =>
                                  x.IsActive == false && x.VendorId == VendorId,
                              ).length
                            }
                          </p>
                        </div>
                        <div className="text-4xl text-red-400">🚫</div>
                      </div>
                    </div>
                    <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-6 border border-blue-200 cursor-pointer hover:shadow-lg transition-shadow">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm font-medium text-blue-800">
                            Requested for Featuring
                          </p>
                          <p className="text-3xl font-bold text-blue-600 mt-2">
                            {
                              lstVendorProperties.filter(
                                (x) =>
                                  x.IsFeatured == false &&
                                  x.IsWantFeatureProperty == true &&
                                  x.VendorId == VendorId,
                              ).length
                            }
                          </p>
                        </div>
                        <div className="text-4xl text-blue-400">📋</div>
                      </div>
                    </div>
                    <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-lg p-6 border border-purple-200 cursor-pointer hover:shadow-lg transition-shadow">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm font-medium text-purple-800">
                            Total Featured Properties
                          </p>
                          <p className="text-3xl font-bold text-purple-600 mt-2">
                            {
                              lstVendorProperties.filter(
                                (x) =>
                                  x.IsFeatured == true &&
                                  x.VendorId == VendorId &&
                                  x.IsActive == true,
                              ).length
                            }
                          </p>
                        </div>
                        <div className="text-4xl text-purple-400">⭐</div>
                      </div>
                    </div>
                    <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-lg p-6 border border-green-200 cursor-pointer hover:shadow-lg transition-shadow">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm font-medium text-green-800">
                            Total Live Properties
                          </p>
                          <p className="text-3xl font-bold text-green-600 mt-2">
                            {
                              lstVendorProperties.filter(
                                (x) =>
                                  x.IsActive == true &&
                                  x.IsPropertyImages == true &&
                                  x.VendorId == VendorId &&
                                  x.IsActive == true,
                              ).length
                            }
                          </p>
                        </div>
                        <div className="text-4xl text-green-400">✅</div>
                      </div>
                    </div>
                    <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-lg p-6 border border-orange-200 cursor-pointer hover:shadow-lg transition-shadow">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm font-medium text-orange-800">
                            Total Properties
                          </p>
                          <p className="text-3xl font-bold text-orange-600 mt-2">
                            {
                              lstVendorProperties.filter(
                                (x) => x.VendorId == VendorId,
                              ).length
                            }
                          </p>
                        </div>
                        <div className="text-4xl text-orange-400">🏠</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="space-y-6">
            <div className="bg-white rounded-xl shadow-sm border border-pink-200 p-6">
              <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
                <h2 className="text-xl font-semibold text-pink-900">
                  Manage Vendors
                </h2>
                <input
                  type="text"
                  className="border border-pink-200 rounded-lg px-4 py-2 w-full md:w-80 focus:outline-none focus:ring-2 focus:ring-pink-200"
                  placeholder="Search Vendor Login Data"
                  value={search}
                  onChange={(e) => setsearch(e.target.value)}
                />
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm border border-pink-200 p-4">
              <DataTable
                columns={coloumn}
                data={filterlstVendorLogin}
                pagination
                highlightOnHover
                responsive
                striped
                defaultSortFieldId={1}
              />
            </div>
          </div>
        </main>
      </Layout>
    </div>
  );
}

export default ManageVendors;
